import { $, $$ } from '@starberry/components';
import { Routes } from '../../routes';

export default {
  $: 'Dashboard',
  title: '',
  content: [
    { $: 'DashboardHero' },
    {
      $: 'ContentSection',
      props: {
        px: $('theme.space.12'),
      },

      title: 'My Property',
      rightLink: {
        text: 'View All',
        href: Routes.MyPropertyPage,
      },

      content: [
        {
          $: 'MyLatestProperty',
        },
      ],
    },
    {
      $: '2Column',
      leftColumn: [
        {
          $: 'SimpleTabs',
          props: {
            colSpan: 6,
            tabListProps: {
              borderBottom: ['1px solid #d8d8d8', null, null, null, 'none'],
              px: [12, null, null, null, 0],
              mx: [-12, null, null, null, 0],
            },
            tabProps: {
              fontSize: $$(
                ('constants.body.bodySize.small'),
                null,
                ('constants.headings.headingSize.h5'),
              ),
              mr: [5, null, 10],
            },
          },
          tabs: [
            {
              title: 'Pending Actions',
              id: 'pending-actions',
              content: { $: 'PendingActions', hideTitle: true },
            },
            {
              title: 'Recent Activity',
              id: 'recent-activity',
              content: { $: 'ActivityHistory', hideTitle: true },
            },
          ],
        },
      ],
      rightColumn: [
        {
          $: 'RoundedCard',
          children: [
            {
              $: 'Text',
              props: {
                fontSize: 20,
              },
              children: 'Value my property',
            },
            {
              $: 'Text',
              props: {
                color: 'gray.700',
              },
              children: 'Book a valuation from one of our property experts.',
            },
            { $: 'ValuationButton' },
          ],
        },
      ],
    },
    {
      $: 'OurServices',
      title: 'Our Services',
    },
    {
      $: 'VideoModule',
    },
  ],
};
